__turbopack_context__.v({
  "card": "Services-module__dpHhBa__card",
  "cardContent": "Services-module__dpHhBa__cardContent",
  "cardDescription": "Services-module__dpHhBa__cardDescription",
  "cardImage": "Services-module__dpHhBa__cardImage",
  "cardImageWrapper": "Services-module__dpHhBa__cardImageWrapper",
  "cardLink": "Services-module__dpHhBa__cardLink",
  "cardTitle": "Services-module__dpHhBa__cardTitle",
  "checkIcon": "Services-module__dpHhBa__checkIcon",
  "featureItem": "Services-module__dpHhBa__featureItem",
  "featureList": "Services-module__dpHhBa__featureList",
  "grid": "Services-module__dpHhBa__grid",
  "icon": "Services-module__dpHhBa__icon",
  "iconWrap": "Services-module__dpHhBa__iconWrap",
  "imageOverlay": "Services-module__dpHhBa__imageOverlay",
  "linkIcon": "Services-module__dpHhBa__linkIcon",
  "services": "Services-module__dpHhBa__services",
});
